import Soglashenie from './Soglashenie';

export default Soglashenie;


// WEBPACK FOOTER //
// ./src/containers/Soglashenie/index.js